module.exports = __webpack_public_path__ + "img/stretch--img1.c45fec76.png";